import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import VideoCard from '../components/VideoCard';
import PlayerModal from '../components/PlayerModal';
import { useStore } from '../context/StoreContext';

const Courses = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const { videos } = useStore();

  const publishedVideos = videos.filter(v => v.status === 'published' && !v.isLive);
  
  // Group by category for the grid layout
  const categories = [...new Set(publishedVideos.map(v => v.category))];

  return (
    <div className="min-h-screen bg-[#07090D] flex flex-col font-sans">
      <Navbar />
      
      <div className="pt-24 md:pt-32 pb-16 container mx-auto px-4 md:px-8 flex-1">
        <div className="mb-10 text-center md:text-left">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">All Courses</h1>
          <p className="text-muted max-w-2xl mx-auto md:mx-0">Explore our comprehensive library of trading strategies, technical analysis, and market mastery courses.</p>
        </div>

        <div className="space-y-12">
          {categories.map(category => {
            const categoryVideos = publishedVideos.filter(v => v.category === category);
            if (categoryVideos.length === 0) return null;
            
            return (
              <div key={category}>
                <h2 className="text-xl md:text-2xl font-semibold text-white mb-6 border-b border-dark-border pb-2">{category}</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
                  {categoryVideos.map(video => (
                    <VideoCard 
                      key={video.id} 
                      video={video} 
                      onPlay={(v) => setActiveVideo(v)} 
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <PlayerModal 
        isOpen={!!activeVideo} 
        onClose={() => setActiveVideo(null)} 
        video={activeVideo} 
      />
    </div>
  );
};

export default Courses;